import { render, staticRenderFns } from "./getwaybill.vue?vue&type=template&id=23370686&scoped=true&"
import script from "./getwaybill.vue?vue&type=script&lang=js&"
export * from "./getwaybill.vue?vue&type=script&lang=js&"
import style0 from "./getwaybill.vue?vue&type=style&index=0&id=23370686&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23370686",
  null
  
)

export default component.exports